import type { ServerConfig } from 'shared-types';

/*
  IMPORTANT
  When supporting a new block type or category, do not forget to 
  edit either the tooltip or the complete checkbox for the relevant
  changes in the SiteSettingsAITools.tsx file (around lines 118 - 143)
*/
const getAISupportedBlocks = (
  allowedBlocks: NonNullable<ServerConfig['aiConfig']>['allowedBlockTypes']
) => {
  if (!allowedBlocks) return [];

  const blocksByKey = {
    image: [
      // 'image'
    ] as const,
    task: [
      'multiplechoice',
      'singlechoice',
      'openquestion',
      'numericquestion',
      'fillin',
      'sequencing'
    ] as const,
    text: ['text', 'heading', 'list', 'quote'] as const
  };

  const supportedBlocks = [
    ...(allowedBlocks.text ? blocksByKey.text : []),
    // ...(allowedBlocks.image ? blocksByKey.image : []),
    ...(allowedBlocks.task ? blocksByKey.task : [])
  ];

  return supportedBlocks;
};

export default getAISupportedBlocks;
